import { ShellEvent, ShellEventTypes } from '@appd/fso-ui-shell/container';

type ShellEventType = keyof typeof ShellEventTypes;
export const emitShellEvent = (eventType: ShellEventType, ...args: any[]): void => {
  if (!(eventType in ShellEventTypes)) {
    console.log(`emitShellEvent: eventType '${eventType}' does not exist in ShellEventTypes.`);
    return;
  }

  ShellEvent?.emit(ShellEventTypes[eventType as ShellEventType], ...args);
};
